import axios from "axios";

//const
const EQUIPMENT_BACKUP_LIST_UPDATE_DATA = "equipmentBackupList/EQUIPMENT_BACKUP_LIST_UPDATE_DATA";
const EQUIPMENT_BACKUP_LIST_STORE_EQUIPMENTS = "equipmentBackupList/EQUIPMENT_BACKUP_LIST_STORE_EQUIPMENTS";
const EQUIPMENT_BACKUP_LIST_STORE_SHOW_EQUIPMENTS = "equipmentBackupList/EQUIPMENT_BACKUP_LIST_STORE_SHOW_EQUIPMENTS";
const EQUIPMENT_BACKUP_LIST_TOGGLE_MODAL = "equipmentBackupList/EQUIPMENT_BACKUP_LIST_TOGGLE_MODAL";
const EQUIPMENT_BACKUP_LIST_TOGGLE_LOADING = "equipmentBackupList/EQUIPMENT_BACKUP_LIST_TOGGLE_LOADING";

const EQUIPMENT_BACKUP_LIST_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentBackupList_modal_success_title";
const EQUIPMENT_BACKUP_LIST_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentBackupList_modal_fail_title";
const EQUIPMENT_BACKUP_LIST_MODAL_OK_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentBackupList_modal_OK_label";
const EQUIPMENT_BACKUP_LIST_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentBackupList_modal_cancel_label";

//reducer
export const equipmentBackupList = (state = {

  loading: false,

  userId: "",
  enterpriseId: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipments: [],
  showEquipments: [],
  name: "",
  equipmentId: "",
  selectedKey: "",
  selectedKeyEquipment: [],

}, action) => {
  switch (action.type) {
    case EQUIPMENT_BACKUP_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_BACKUP_LIST_STORE_EQUIPMENTS:
      return {
        ...state,
        equipments: action.data,
        showEquipments: action.data,
        selectedKey: "",
        selectedKeyEquipment: [],
      };
    case EQUIPMENT_BACKUP_LIST_STORE_SHOW_EQUIPMENTS:
      return {
        ...state,
        showEquipments: action.data,
        selectedKey: "",
        selectedKeyEquipment: [],
      };
    case EQUIPMENT_BACKUP_LIST_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_BACKUP_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentData = (data) => {
  return {
    type: EQUIPMENT_BACKUP_LIST_UPDATE_DATA,
    data: data
  }
};

/**
 * init equipments
 */
export const initEquipments = (data) => (dispatch) => {
  dispatch(toggleLoading(true));

  dispatch(updateEquipmentData({
    name: "enterpriseId",
    value: data.enterpriseId
  }));
  axios.get(`/api-equipment/getEquipmentList/${data.enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipments(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipments
 */
export const storeEquipments = (equipments) => {
  return {
    type: EQUIPMENT_BACKUP_LIST_STORE_EQUIPMENTS,
    data: equipments
  }
};

/**
 * filter equipments
 */
export const filterEquipment = (data) => (dispatch) => {
  let showEquipments = data.equipments.filter(equipment => {
    return equipment.equipmentType.name.indexOf(data.name) > -1
  });
  dispatch(storeShowEquipments(showEquipments));
};

/**
 * store show equipments
 */
export const storeShowEquipments = (equipments) => {
  return {
    type: EQUIPMENT_BACKUP_LIST_STORE_SHOW_EQUIPMENTS,
    data: equipments
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_BACKUP_LIST_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_BACKUP_LIST_TOGGLE_LOADING,
    data: show
  }
};

export class stopEquipment {
}
